import Divider from '@mui/material/Divider';
import Box from '@mui/system/Box';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@mui/material';

const StaffContactDetailsSkeleton = ({ id }) => {
  const { t } = useTranslation('translations');
  return (
    <div className="w-full max-w-640">
      <Box
        className="relative w-full h-96 px-32 sm:px-48"
        sx={{
          backgroundColor: 'background.default',
        }}
      ></Box>
      <div className="relative flex flex-col flex-auto items-center p-24 pt-0 sm:p-48 sm:pt-0 dark:bg-dark">
        <div className="w-50">
          <div className="flex items-end -mt-64">
            <Skeleton variant="circular" width={128} height={128} />
          </div>
          <Skeleton variant="text" height={64} />
          <div className="flex flex-col gap-16">
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <div className="flex items-center gap-10">
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="circular" width={40} height={40} />
            </div>
            <Skeleton variant="text" />
            <Divider className="my-8" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffContactDetailsSkeleton;
